import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const DraftNoEditAccessBanner = () => {
  const { t } = useTranslation();
  return (
    <Box mt="4">
      <Alert status="info" rounded="md" fontSize="sm" alignItems="flex-start">
        <AlertIcon />
        <Box>
          <AlertTitle>{t("This procurement is still a draft")}</AlertTitle>
          <AlertDescription>
            {t("You don't have permission to edit it. Ask an administrator in your organization for edit access.")}
          </AlertDescription>
        </Box>
      </Alert>
    </Box>
  );
};
